/**
 * rolexMultiStoreDetailOverlay.js
 * Synchronizes store services (Retailer, RCPO, Service Centre)
 * between the clicked store item list card and the multi-store detail overlay
 */
export default function rlxMultiStoreDetailOverlay() {
    const SELECTORS = {
        STORE_ITEM: '.js-store-item, .rlx-v7-locator__store-list-item',
        DETAILS_MODAL: '.js-rlx-v7-store-details',
        SERVICE_RETAILER: '.js-service-retailer',
        SERVICE_RCPO: '.js-service-rcpo',
        SERVICE_CENTRE: '.js-service-service-centre',
    };

    /**
     * Updates service visibility inside the details overlay based on data attributes
     * @param {jQuery} $storeItem
     */
    const syncServicesToDetails = ($storeItem) => {
        if (!$storeItem || !$storeItem.length) return;

        const isRetailer = $storeItem.attr('data-service-retailer') === 'true';
        const isRcpo = $storeItem.attr('data-service-rcpo') === 'true';
        const isServiceCentre = $storeItem.attr('data-service-service-centre') === 'true';

        const $detailsModal = $(SELECTORS.DETAILS_MODAL);

        if ($detailsModal.length) {
            $detailsModal.find(SELECTORS.SERVICE_RETAILER).toggle(isRetailer);
            $detailsModal.find(SELECTORS.SERVICE_RCPO).toggle(isRcpo);
            $detailsModal.find(SELECTORS.SERVICE_CENTRE).toggle(isServiceCentre);
        }
    };

    // 1. Delegated click handler: Triggers when clicking a store card or detail link
    $(document).off('click.rolexMultiStoreDetailOverlay', SELECTORS.STORE_ITEM)
        .on('click.rolexMultiStoreDetailOverlay', SELECTORS.STORE_ITEM, (e) => {
            const $storeItem = $(e.currentTarget);

            // Brief deferral to ensure modal DOM rendering is complete
            setTimeout(() => {
                syncServicesToDetails($storeItem);
            }, 50);
        });

    // 2. Event subscriber fallback for Shopware modal lifecycle
    if (window.$ && window.$.subscribe) {
        window.$.subscribe('plugin/swModal/onOpen', () => {
            const $activeStore = $(SELECTORS.STORE_ITEM).filter('.is--active, .selected').first();
            if ($activeStore.length) {
                syncServicesToDetails($activeStore);
            }
        });
    }
}
